// media-library-grid-file-view.component.ts
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgxTippyProps } from 'ngx-tippy-wrapper';
import { MediaLibraryFileModel } from 'src/app/models/sales-funnel';
import { DropdownItem } from '../../../dynamic-dropdown/dynamic-dropdown.component';
import { Store } from '@ngrx/store';
import { PromptingService } from 'src/app/shared/services';
import { MediaLibraryFileActions } from 'src/app/shared/store/_features/media-library/media-library.actions';

@Component({
  selector: 'app-media-library-grid-file-view',
  templateUrl: './media-library-grid-file-view.component.html',
  styleUrls: ['./media-library-grid-file-view.component.css'],
})
export class MediaLibraryGridFileViewComponent implements OnInit {
  tippyImageProps: NgxTippyProps = {
    trigger: 'click',
    followCursor: false,
    allowHTML: true,
    appendTo: document.body,
    placement: 'auto',
    maxWidth: 550,
    interactive: true,
  };

  tippyVideoProps: NgxTippyProps = {
    trigger: 'click',
    followCursor: false,
    allowHTML: true,
    interactive: true,
    appendTo: document.body,
    placement: 'auto',
    maxWidth: 650,
  };

  iframeLoaded: boolean = false;
  defaultVideoThumb = 'assets/images/svg/files/video.svg';

  @Input() item: MediaLibraryFileModel;
  @Input() selected: boolean = false;
  @Output() onClickActiveArea = new EventEmitter<MediaLibraryFileModel>();
  @Output() onStartDeleting = new EventEmitter();

  dropdownItems: DropdownItem[] = [];

  constructor(
    private store: Store,
    private prompting: PromptingService,
  ) {}

  ngOnInit() {
    this.generateFileDropdown();
  }

  frameLoaded() {
    this.iframeLoaded = true;
  }

  selectFile() {
    this.onClickActiveArea.emit(this.item);
  }

  generateFileDropdown() {
    this.dropdownItems = [
      {
        label: 'Delete',
        iconSvg: 'assets/images/svg/system/trash.svg',
        colorSet: 'danger',
        colorSetHover: 'danger',
        action: () => this.deleteFile(this.item),
      },
    ];
  }

  downloadFile(item: MediaLibraryFileModel) {
    window.open(item.url, '_blank');
  }

  deleteFile(item: MediaLibraryFileModel) {
    this.prompting
      .confirm(
        {
          title: 'Delete this file?',
          html: `
        <div class="text-center">
          <p class="text-gray-600 mb-3">This action cannot be undone.</p>
          <div class="bg-gray-50 rounded-lg p-3 mb-3">
            <p class="font-medium text-gray-800">${item.fileInfo?.displayName}</p>
            <p class="text-sm text-gray-500">${item.fileInfo?.ext} • ${this.getFileSize(item.fileInfo?.size)}</p>
          </div>
        </div>
      `,
          icon: 'warning',
          input: !!item?.used ? 'checkbox' : undefined,
          inputPlaceholder: `I understand this file may be in use`,
          preConfirm: async (isForced) => {
            this.store.dispatch(
              MediaLibraryFileActions.delete({ file: item, force: !!isForced }),
            );
            return true;
          },
          confirmButtonText: 'Delete File',
          cancelButtonText: 'Cancel',
          showLoaderOnConfirm: true,
          inputValidator: (result) => {
            return !result && 'You need to confirm';
          },
          isDanger: true,
        },
        'md',
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.onStartDeleting.emit();
        }
      });
  }

  getFileSize(bytes: number): string {
    if (!bytes) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${(bytes / Math.pow(k, i)).toFixed(1)} ${sizes[i]}`;
  }
}
